import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import type { Field } from "@project/admin/components/resource-table";
import { gruhUdhyogCategoryService } from "@project/services/admin/gruh-udhyog-category.service";
import type {
  ProductCategory,
  ProductCategoryPayload,
} from "@project/types/gruh-udhyog";

const fields: Field[] = [
  {
    name: "category_name",
    label: "Category Name",
    required: true,
    showInTable: true,
    placeholder: "e.g. Khakhra",
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    showInTable: true,
    placeholder: "Category description...",
  },
  {
    name: "is_active",
    label: "Active",
    type: "boolean",
    showInTable: true,
  },
];

function toPayload(payload: Record<string, unknown>): ProductCategoryPayload {
  return {
    category_name: String(payload.category_name ?? "").trim(),
    description: payload.description
      ? String(payload.description).trim()
      : undefined,
    is_active: payload.is_active === true || payload.is_active === "true",
  };
}

export default function ProductCategoriesPage() {
  return (
    <AdminShell
      title="Product Categories"
      subtitle="Manage Gruh Udhyog product categories"
    >
      <ApiResourceTable<ProductCategory>
        title="Category"
        labelField="category_name"
        fields={fields}
        searchFields={["category_name", "description"]}
        defaultValues={{ is_active: true }}
        statusFilterOptions={[
          { value: "active", label: "Active" },
          { value: "inactive", label: "Inactive" },
        ]}
        csvFileName="product-categories"
        list={query => gruhUdhyogCategoryService.listPage(query)}
        loadRecordForEdit={id => gruhUdhyogCategoryService.get(id)}
        create={payload => gruhUdhyogCategoryService.create(toPayload(payload))}
        update={(id, payload) =>
          gruhUdhyogCategoryService.update(id, toPayload(payload))
        }
        remove={id => gruhUdhyogCategoryService.delete(id)}
      />
    </AdminShell>
  );
}
